export const KvReportProtocolConfig = {
    quality: {
        cmdid: 2,
        logid: 16145,
        columns: [{
            key: 'PageKey',
            index: 21,
            type: 1, // 上报类型 1原生上报， 2 web上报
        }, {
            key: 'Network',
            index: 22,
            type: 1,
        }, {
            key: 'DeviceLevel',
            index: 23,
            type: 1,
        }, {
            key: 'Url',
            index: 24,
            type: 1,
        }, {
            key: 'IsWepkg',
            index: 25,
            type: 1,
        }, {
            key: 'IsLuggage',
            index: 26,
            type: 1,
        }, {
            key: 'IsPreload',
            index: 27,
            type: 1,
        }, {
            key: 'WepkgVersion',
            index: 28,
            type: 1,
        }, {
            key: 'CommJsVersion',
            index: 29,
            type: 1,
        }, {
            key: 'Type',
            index: 30,
            type: 2,
            default: 0,
        }, {
            key: 'Target',
            index: 31,
            type: 2,
            default: '',
        }, {
            key: 'Params',
            index: 32,
            type: 2,
            default: '',
        }, {
            key: 'Result',
            index: 33,
            type: 2,
            default: '',
        }, {
            key: 'CostTime',
            index: 34,
            type: 2,
            default: 0,
        }, {
            key: 'CurrentUrl',
            index: 35,
            type: 2,
            default: '',
        }, {
            key: 'IsError',
            index: 36,
            type: 2,
            default: 0,
        }, {
            key: 'IsLiteApp',
            index: 37,
            type: 2,
            default: 0,
        }, {
            key: 'BuildVersion',
            index: 38,
            type: 2,
            default: 0,
        }]
    }
}
export const msgToKvString = (data, columns) => {
    const kvString = columns.map((column) => {
        const index = column.index;
        if (!(index in data)) {
            return 0;
        }
        const value = data[index];
        if (value === void 0) {
            return 0;
        }
        return value;
    }).join(',');
    return kvString;
}